// Massive thanks to javier and team for the following code.
// also, for more context, see here https://github.com/ingka-group-digital/salpay-cart-client/pull/1638
import jwtDecode from "jwt-decode";

/**
 * Modified from salpay-cart-client code.
 * @returns {Promise} if successful, contains an object with valid accessToken (for signed in user)
 * or null values (for a guest user). else, rejects with error.
 */
export const getToken = () => {
    return new Promise((resolve, reject) => {
        return window.ikea.authentication.getTokens(async (error, tokens) => {
            if (error) {
                return reject(error);
            }
            return resolve({
                accessToken: pickToken(tokens)
            });
        });
    });
};

/**
 * Modified from salpay-cart-client code. Normally returns an
 * authorized or a guest token, but we only need auth token.
 * @param {Object} tokens response from getTokens call, contains an auth and guest token.
 * @returns {Object} decoded authorization token or null
 */
const pickToken = (tokens) => (tokens.auth && !isExpiredOrInvalidToken(tokens.auth.value) ? tokens.auth.value : null);

/**
 * Modified from salpay-cart-client code.
 * @param {String} accessToken JWT for authorized user
 * @returns {Boolean} true if the token is expired or invalid
 */
const isExpiredOrInvalidToken = (accessToken) => {
    if (accessToken) {
        const decodedToken = jwtDecode(accessToken);
        return decodedToken?.exp < new Date().getTime() / 1000;
    }
    return true;
};
